import { createSelector } from '@reduxjs/toolkit';
import moment from 'moment';

export const masterOrdersListParentsSelector = createSelector(
  state => state.rxOrders.masterOrders,
  subState => subState.filter(obj => !obj.parentId),
);

export const masterOrdersListSelector = createSelector(
  state => state.rxOrders.masterOrders,
  subState => subState,
);

export const activeOrdersSelector = createSelector(
  state => state.rxOrders.newOrders,
  subState => subState,
);

export function normalizeDataIntoApptDates(ordersArr) {
  const normalizedOrders = {};
  ordersArr.map(a => {
    let { appointmentId } = a;
    if (normalizedOrders[appointmentId]) {
      normalizedOrders[appointmentId].push(a);
    } else {
      normalizedOrders[appointmentId] = [a];
    }
  });
  return normalizedOrders;
}

export const activePatientOrdersSelector = createSelector(
  state => state.rxOrders.activePatientOrders,
  subState => normalizeDataIntoApptDates(subState),
);

export const activeAppointmentOrdersSelector = createSelector(
  state => state.rxOrders.activeAppointmentOrders,
  subState => normalizeDataIntoApptDates(subState),
);

export const appointmentDiagnosisSelector = createSelector(
  state => state.rxOrders.appointmentDiagnosisList,
  subState => subState,
);

export const getOrderStepSelector = createSelector(
  state => state.rxOrders.orderStep,
  subState => subState,
);
